export default {
      id: "tt-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#tt",
      toString: function () {
        return this.url;
      }
    }